/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Print_LabelInputs */

const vi_carrier_print_label = /** @type {(inputs: Carrier_Print_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In vận đơn`)
};

/**

* @param {Carrier_Print_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_print_label = /** @type {((inputs?: Carrier_Print_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Print_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_print_label(inputs)
});